import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output
} from "@angular/core";
import { Domain, SECURITY_DOMAIN } from "@app2/alert/constants";
import { QueryTrigger } from "@app2/clients/types/alert-typedefs";
import { PRODUCT_DOMAIN } from "@app2/alert/alert-inbox/injection-tokens";
import { RouterService } from "@app2/shared/services/router.service";

@Component({
    selector: "trigger-header",
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <h2 id="trigger-header" test-id="trigger-header" [class.sticky]="isSticky">
            <severity-icon [severity]="currentTrigger.severity" [description]="true"></severity-icon>
            <span>-</span>
            <a *ngIf="showNameLink"
               dsRouterLink="."
               [queryParams]="{ mode: 'trigger', selected: currentTrigger.id }"
               queryParamsHandling="merge"
               test-class="trigger-name-link">{{ currentTrigger.name }}</a>
            <span id="trigger-name" *ngIf="!showNameLink"
                  [matTooltip]="currentTrigger.name"
                  [matTooltipDisabled]="!titleOverflows()"
                  (window:resize)="onResize()"
                  test-class="trigger-name">{{ currentTrigger.name }}
            </span>
            <span class="de-emphasize" *ngIf="currentTrigger.type === 'threat'">
                [{{ "THREAT_MATCH" | localize }}]
            </span>
            <ng-container *dsPermissionsRequired="'TRIGGER_VIEW'">
                <a class="link-text" id="manage-trigger"
                   *ngIf="currentTrigger.type !== 'threat'"
                   (click)="viewTrigger()">
                    <i [matTooltip]="'MANAGE_TRIGGER' | localize" class="fal fa-pen"></i>
                </a>
            </ng-container>
        </h2>
    `,
    styles: [`
      #trigger-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      #trigger-header {
        display: flex;
        gap: 4px;
        align-items: baseline;
      }

      #manage-trigger {
        margin-left: auto;
        font-size: 1.5rem;
        padding-top: 2px;
      }
    `]
})
export class TriggerHeaderComponent implements OnInit {
    @Input() currentTrigger: QueryTrigger;
    @Input() showNameLink: boolean;
    @Input() isSticky: boolean = true;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onTriggerNameClicked = new EventEmitter<void>();

    constructor(private cd: ChangeDetectorRef,
                @Inject(PRODUCT_DOMAIN) private productDomain: Domain,
                private routerService: RouterService) {
    }

    ngOnInit() {
        this.cd.detectChanges();
        this.onResize();
    }

    viewTrigger() {
        if (this.productDomain === SECURITY_DOMAIN) {
            this.routerService.navigate(["/triggers", this.currentTrigger.id]);
        } else {
            this.routerService.navigate(["/fraud/triggers", this.currentTrigger.id]);
        }
    }

    titleOverflows(): boolean {
        const triggerName = document.getElementById("trigger-name");
        if (triggerName) {
            return triggerName.offsetWidth < triggerName.scrollWidth;
        }
        return false;
    }

    onResize() {
        this.cd.markForCheck();
    }
}
